import React, { useState, useEffect } from 'react';
import {useSelector, connect} from 'react-redux';
import Fade from '@material-ui/core/Fade';
//import Zoom from '@material-ui/core/Zoom';
import * as actionsPolicy from '../../app/actions/policy';
import InitialDataScreen from './components/liabilityPolicy/InitialDataScreen';
import OffersList from './components/liabilityPolicy/OffersList';
import MissingRegFields from './components/liabilityPolicy/MissingRegFields';
import QuestionnaireVehicle from './components/liabilityPolicy/QuestionnaireVehicle';
import QuestionnaireOwner from './components/liabilityPolicy/QuestionnaireOwner';
import UplaodTalonPic from './components/liabilityPolicy/UploadTalonPic';
import OwnerDetailsContainer from './components/liabilityPolicy/OwnerDetailsContainer';
import OwnerAddress from './components/liabilityPolicy/OwnerAddress';
import Registration from './components/liabilityPolicy/Registration';
import UserDetails from './components/liabilityPolicy/UserDetails';
import UserAddress from './components/liabilityPolicy/UserAddress';
import DeliveryDetails from './components/liabilityPolicy/DeliveryDetails';
import Summary from './components/liabilityPolicy/Summary';
import PaymentWithCard from './components/liabilityPolicy/PaymentWithCard';
import PaymentSuccess from './components/liabilityPolicy/PaymentSuccess';
import PaymentCashOnDelivery from './components/liabilityPolicy/PaymentCashOnDelivery';
import PaymentConDSuccess from './components/liabilityPolicy/PaymentConDSuccess';


let LiabilityPolicy = ({setStepLiability, setGoToLiability}) => {

  const liabilityStep = useSelector(state => state.liabilityStep);
  const {goToLiability} = liabilityStep;

  const [step, setStep] = useState(liabilityStep?.step ? liabilityStep.step : 1);
  const [stepBack, setStepBack] = useState(null);
  const [showFade, setShowFade] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    setStepLiability(step);
  }, [step, setStepLiability]);

  useEffect(()=>{
    if(goToLiability) setGoToLiability(false); //this is used for profileLogin when called from OwnerAddress screen;
  }, [goToLiability, setGoToLiability]);

  const onBack = (toStep) => {
      toStep = stepBack ? stepBack : toStep;
      setShowFade(false);

      setTimeout(() => {
        setStep(toStep);
        setStepBack(null);
        setShowFade(true);
      }, 0);
  }

  const onForward = (toStep, backTo) => {
      backTo ? setStepBack(backTo) : setStepBack(false);
      setShowFade(false);

      setTimeout(() => {
        setStep(toStep);
        setShowFade(true);
      }, 0);
      
  }

  const renderStepScreen = () => {
      switch (step) {
          case 1:
            return <InitialDataScreen onForward={onForward} />;
          case 2:
            return <QuestionnaireVehicle onBack={onBack} onForward={onForward} />;
          case 3:
            return <MissingRegFields onBack={onBack} onForward={onForward} />;
          case 4:
            return <QuestionnaireOwner onBack={onBack} onForward={onForward} />;
          case 6:
            return <OffersList onBack={onBack} onForward={onForward} />;
          case 7:
            return <UplaodTalonPic onBack={onBack} onForward={onForward} />;
          case 8:
            return <OwnerDetailsContainer onBack={onBack} onForward={onForward} />;
          case 9:
            return <OwnerAddress onBack={onBack} onForward={onForward} />;
          case 10:
            return <Registration onBack={onBack} onForward={onForward} />;
          case 11:
            return <UserDetails onBack={onBack} onForward={onForward} />;
          case 12:
            return <UserAddress onBack={onBack} onForward={onForward} />;
          case 13:
            return <DeliveryDetails onBack={onBack} onForward={onForward} />;
          case 14:
            return <Summary onBack={onBack} onForward={onForward} />;
          case 15:
            return <PaymentWithCard onBack={onBack} onForward={onForward} />;
          case 16:
            return <PaymentSuccess />;
          case 17:
            return <PaymentCashOnDelivery onBack={onBack} onForward={onForward} />;
          case 18:
            return <PaymentConDSuccess />;

          default:
            return <div></div>;
      }
  }

  return (
      <div style={{position: 'realtive'}}>
          <Fade in={showFade} timeout={{enter: 600, exit: 0}} disableStrictModeCompat={true}>
            {renderStepScreen()}
          </Fade>
      </div>
  )
}

export default connect(null, {...actionsPolicy})(LiabilityPolicy);